import React from 'react';
import PropTypes from 'prop-types';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import qhistory from 'qhistory';
import queryString from 'query-string';
import RestoreScroll from './RestoreScroll';


const history = qhistory(
    createBrowserHistory(),
    queryString.stringify,
    queryString.parse
);

export default function QueryRouter({ children, shouldRestoreScroll }) {
    return (
        <Router history={history}>
            {shouldRestoreScroll && <RestoreScroll />}
            {children}
        </Router>
    )
}

QueryRouter.propTypes = {
    /** Component that includes Routes */
    children: PropTypes.node,

    /** If true, the window scroll position will be set to 0,0 when the
     * location pathname changes */
    shouldRestoreScroll: PropTypes.bool
}

QueryRouter.defaultProps = {
    shouldRestoreScroll: true
}